import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class PayGatePaymentResponse {
  /**
   * TerminalId.
   */
  @observable
  terminalId?: string;

  /**
   * Transaction ident from POS merchant.
   */
  @observable
  terminalSequenceIdent?: string;

  /**
   * Card number.
   */
  @observable
  cardNumber?: string;

  /**
   * Acquirer reference number.
   */
  @observable
  arn?: string;

  /**
   * PayGate transaction authorization code
   */
  @observable
  authCode?: string;

  /**
   * PayGate payment ident.
   */
  @observable
  payGatePaymentIdent?: string;

  @observable
  merchantId!: string;

  @observable
  @Type(() => Date)
  authorizedAt!: Date;

  @observable
  invoiceNumber!: string;

  @observable
  paidAmount!: number;
}

export default class PayGatePayment extends PayGatePaymentResponse {
  @observable
  @Type(() => DomesticBankAccountResponse)
  merchantBankAccount!: DomesticBankAccountResponse;
}
